// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Zyv9","titleAndContent":"_1e9qv","title":"_1PBHW","subtitle":"_2ldtH","subtitleText":"_5LMuF","content":"_29gci","extraFooterSpacing":"hg5rZ"};